import { actionTypes } from './constants';

export const stackPagesActionTypes = {
  setSelectedRunIds: actionTypes.STACK_PAGES_SET_SELECTED_RUN_IDS,
  setFetching: actionTypes.STACK_PAGES_SET_FETCHING,
};
